import { useBusinessContext } from '@root/context'
import { fetchTags } from '@root/query/tags'
import { keepPreviousData, useInfiniteQuery, useQuery } from '@tanstack/react-query'

interface InfiniteTagsProps {
  search?: string
  enabled?: boolean
}

export const useInfiniteTags = ({ search, enabled = true }: InfiniteTagsProps) => {
  const { slug } = useBusinessContext()

  return useInfiniteQuery({
    queryKey: [slug, 'tags', { search }],
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) => fetchTags({ slug }, { page: pageParam, search }),
    getNextPageParam: lastPage => lastPage.next,
    getPreviousPageParam: lastPage => lastPage.prev,
    enabled,
    staleTime: 60 * 1000 // Stale time of 1 min in ms
  })
}

interface UseTagsProps {
  tagIds: number[]
}

export const useTags = ({ tagIds }: UseTagsProps) => {
  const { slug } = useBusinessContext()

  return useQuery({
    queryKey: [slug, 'tags', tagIds],
    queryFn: () => fetchTags({ slug }, { ids: tagIds, page_size: tagIds.length }),
    ...{
      enabled: !!tagIds?.length,
      placeholderData: keepPreviousData,
      staleTime: 15 * 60 * 1000 // Adding stale time to 15 min in ms to avoid refetching
    }
  })
}
